import * as S from './style'

export function HeaderPublic (): React.ReactElement {
  return <S.HeaderForpy style={{ padding: '0 16px', background: 'var(--white-light)' }}>
    <div>
      <a href='/login'>Entre</a>
    </div>
    <S.LogoSmall />
  </S.HeaderForpy>
}
